import React, { useState, useEffect, createRef, createContext } from "react";
import { FeedUpdate } from "../FeedUpdate/FeedUpdate";
import { RfxByCodeActivities } from "../../schema";
import { Loading } from "../Loading/Loading";
import { StringToRefObjectMap } from "../../services/scrollIntoViewByRef";
import styles from "./CollaborationSidebar.module.scss";

export interface CollaborationSideBarProps {
  activities: RfxByCodeActivities[];
  showActivityLoader?: boolean;
}

export const ActivityRefsContext: React.Context<StringToRefObjectMap> =
  createContext(new Map());

export const CollaborationSidebar: React.FC<CollaborationSideBarProps> = ({
  activities,
  showActivityLoader,
}) => {
  const [showLoader, setShowLoader] = useState<boolean | undefined>(false);

  const activityRefs = activities.reduce((acc, value) => {
    acc.set(value.id, createRef());

    return acc;
  }, new Map() as StringToRefObjectMap<HTMLLIElement>);

  useEffect(() => {
    setShowLoader(showActivityLoader);
  }, [showActivityLoader]);

  return (
    <>
      {showLoader && <Loading />}
      <ul className={styles["activities-list"]}>
        {activities &&
          activities.map((activity) => {
            return (
              <li
                className={styles["activities-list-item"]}
                key={activity.id}
                ref={activityRefs.get(activity.id)}
              >
                <ActivityRefsContext.Provider value={activityRefs}>
                  <FeedUpdate
                    activity={activity}
                    setShowLoader={setShowLoader}
                  />
                </ActivityRefsContext.Provider>
              </li>
            );
          })}
      </ul>
    </>
  );
};
